import React from 'react'
import {buildDecoration} from './build_decoration'

const getFieldElement = event => event.currentTarget.closest('.eitje-form-3-field')

const hasClass = (element, className) => element.classList.contains(className)

const focusNextSibling = element => {
	let {nextSibling} = element

	if (!nextSibling && hasClass(element.parentElement, 'eitje-form-3-row')) {
		nextSibling = element.parentElement?.nextSibling?.children[0]
	}

	if (!nextSibling) return
	while (nextSibling && !nextSibling.className) {
		// sometimes nextSibling is just 'text' and that doesn't have a className
		nextSibling = nextSibling.nextSibling
	}
	if (hasClass(nextSibling, 'disabled') || hasClass(nextSibling, 'read-only')) return focusNextSibling(nextSibling)

	if (hasClass(nextSibling, 'eitje-form-3-field')) {
		const input = nextSibling.querySelector('input') || nextSibling.querySelector('textarea') || nextSibling.querySelector('button')
		input?.focus?.()
	} else {
		const submitButton = nextSibling.classList.contains('form-submit-button')
			? nextSibling
			: nextSibling.querySelector('.form-submit-button')
		if (submitButton) submitButton.click()
	}
}

const handleKeyPress = e => {
	if (e.key != 'Enter') return
	const element = getFieldElement(e)
	if (!element) return
	focusNextSibling(element)
}

export const FieldInput = ({Comp, ...rest}) => {
	const label = buildDecoration({...rest, decorationType: 'label'})
	return <Comp {...rest} placeholder="..." onKeyDown={handleKeyPress} title={label} {...rest} />
}
